import { FormGroup, AbstractControl } from "@angular/forms";

const Months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];

// tslint:disable-next-line:max-line-length
export const VALIDEMAILREGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\d\s:])([^\s]){8,}$/;


export const PHONE_PATTERN = /^[0-9]{10}$/;


export const CONTAINSPECIALCHAR = /^[\w-_ \-]*$/;

export const AMOUNTBYDATESPLITER = (payload, arrayNumber) => {
  const returnValue = {};
  if (arrayNumber == 1) {
    for (const item of payload) {
      const { itemCost, createdDate } = item;
      const splitCreatedAt = createdDate.split("-");
      const month = Number(splitCreatedAt[1]) - 1;

      if (!returnValue[month]) {
        returnValue[month] = Number(itemCost);
      } else {
        returnValue[month] += Number(itemCost);
      }
    }
  } else {
    for (const item of payload) {
      const { createdOn, totalCost } = item;
      const stringDate = new Date(createdOn);
      const splitCreatedOn = stringDate.toDateString().split(" ")[1].toUpperCase();
      const month = (Months.indexOf(splitCreatedOn));
      if (!returnValue[month]) {
        returnValue[month] = Number(totalCost);
      } else {
        returnValue[month] += Number(totalCost);
      }
    }
  }

  const returnDataArray = new Array(12).fill(0);
  Object.keys(returnValue).forEach(key => returnDataArray[key] = returnValue[key])
  return returnDataArray;
};

export const INVOICECHARTDATA = (payload, type, viewType?) => {
  const returnValue = {};
  for (const item of payload) {
    const {
      createdOn,
      totalCost,
      paymentHistory,
      balanceDue,
      paymentDueDate,
    } = item;
    if (type === "totalInvoice") {
      const monthQuater = dateManipulationForChart(createdOn, viewType)

      if (!Object.keys(returnValue).includes(monthQuater)) {
        returnValue[monthQuater] = Number(totalCost);
      } else {
        returnValue[monthQuater] += Number(totalCost);
      }
    } else if (type === "paymentReceived") {
      paymentHistory.map((res) => {
        // const stringDate = new Date(res.date);
        // const splitCreatedOn = stringDate.toDateString().split(" ")[1].toUpperCase();
        // const monthQuater = (Months.indexOf(splitCreatedOn) + 1).toString();
        const monthQuater = dateManipulationForChart(res.date, viewType);

        if (!Object.keys(returnValue).includes(monthQuater)) {
          returnValue[monthQuater] = Number(res.amountPaid);
        } else {
          returnValue[monthQuater] += Number(res.amountPaid);
        }
      });
    } else if (type === "unpaid") {
      if (!HAS_OUTSTANDING_INVOICE_BALANCE(item)) {
        continue;
      }
      const monthQuater = dateManipulationForChart(createdOn, viewType);
      // const stringDate = new Date(createdOn);
      // const splitCreatedOn = stringDate.toDateString().split(" ")[1].toUpperCase();
      // const monthQuater = (Months.indexOf(splitCreatedOn) + 1).toString();
      if (!Object.keys(returnValue).includes(monthQuater)) {
        returnValue[monthQuater] = Number(balanceDue);
      } else {
        returnValue[monthQuater] += Number(balanceDue);
      }
    } else if (type === "overdues") {
      // const stringDate = new Date(paymentDueDate);
      // const splitCreatedOn = stringDate.toDateString().split(" ")[1].toUpperCase();
      // const monthQuater = (Months.indexOf(splitCreatedOn) + 1).toString();
      const monthQuater = dateManipulationForChart(paymentDueDate, viewType);
      const today = Date.parse(new Date().toISOString());

      if (!Object.keys(returnValue).includes(monthQuater)) {
        if (today > paymentDueDate) {
          returnValue[monthQuater] = Number(balanceDue);
        }
      } else {
        if (today > paymentDueDate) {
          returnValue[monthQuater] += Number(balanceDue);
        }
      }
    }
  }

  const returnDataArray = [];

  if (Object.keys(returnValue).length !== 0) {
    let i = 1;
    if (viewType === 'quarter') {
      while (i < 5) {
        if (returnValue[i]) {
          returnDataArray.push(returnValue[i]);
        } else {
          returnDataArray.push(0);
        }
        i++;
      }
    } else {
      while (i < 13) {
        if (returnValue[i]) {
          returnDataArray.push(returnValue[i]);
        } else {
          returnDataArray.push(0);
        }
        i++;
      }
    }
    return returnDataArray;
  } else {
    return returnDataArray;
  }
};

export const HAS_OUTSTANDING_INVOICE_BALANCE = (invoice) => {
  return Number(invoice.balanceDue) > 0;
};

export const SUBSCRIPTIONCHARTDATA = (payload, format, viewType?) => {
  const returnValue = {
    active: {},
    due: {},
    suspended: {},
    terminated: {},
  };
  for (const item of payload) {
    const {
      createdOn,
      totalCost,
      isActive,
      isSuspended,
      isTerminated,
      endDate
    } = item;
    const monthQuater = dateManipulationForChart(createdOn, viewType)
    const today = new Date().setHours(0, 0, 0, 0)

    // Active
    if (isActive && !isTerminated && !isSuspended) {
      if (format === 'amount') {
        if (!Object.keys(returnValue.active).includes(monthQuater)) {
          returnValue.active[monthQuater] = Number(totalCost);
        } else {
          returnValue.active[monthQuater] += Number(totalCost);
        }
      } else {
        if (!Object.keys(returnValue.active).includes(monthQuater)) {
          returnValue.active[monthQuater] = 1;
        } else {
          returnValue.active[monthQuater]++;
        }
      }
    }

    // Due
    if (today > endDate && !isTerminated && !isSuspended) {
      if (format === 'amount') {
        if (!Object.keys(returnValue.due).includes(monthQuater)) {
          returnValue.due[monthQuater] = Number(totalCost);
        } else {
          returnValue.due[monthQuater] += Number(totalCost);
        }
      } else {
        if (!Object.keys(returnValue.due).includes(monthQuater)) {
          returnValue.due[monthQuater] = 1;
        } else {
          returnValue.due[monthQuater]++;
        }
      }
    }

    // Suspended
    if (isSuspended && !isTerminated) {
      if (format === 'amount') {
        if (!Object.keys(returnValue.suspended).includes(monthQuater)) {
          returnValue.suspended[monthQuater] = Number(totalCost);
        } else {
          returnValue.suspended[monthQuater] += Number(totalCost);
        }
      } else {
        if (!Object.keys(returnValue.suspended).includes(monthQuater)) {
          returnValue.suspended[monthQuater] = 1;
        } else {
          returnValue.suspended[monthQuater]++;
        }
      }
    }

    // Terminated
    if (isTerminated) {
      if (format === 'amount') {
        if (!Object.keys(returnValue.terminated).includes(monthQuater)) {
          returnValue.terminated[monthQuater] = Number(totalCost);
        } else {
          returnValue.terminated[monthQuater] += Number(totalCost);
        }
      } else {
        if (!Object.keys(returnValue.terminated).includes(monthQuater)) {
          returnValue.terminated[monthQuater] = 1;
        } else {
          returnValue.terminated[monthQuater]++;
        }
      }
    }

  }

  const returnDataArray = {
    active: [],
    due: [],
    suspended: [],
    terminated: [],
  };

  if (Object.keys(returnValue).length !== 0) {
    let i = 1;
    let activeResult = returnValue.active;
    let dueResult = returnValue.due;
    let suspendedResult = returnValue.suspended;
    let terminatedResult = returnValue.terminated;
    if (viewType === 'quarter') {
      while (i < 5) {
        if (activeResult[i]) {
          returnDataArray.active.push(activeResult[i]);
        } else {
          returnDataArray.active.push(0);
        }

        if (dueResult[i]) {
          returnDataArray.due.push(dueResult[i]);
        } else {
          returnDataArray.due.push(0);
        }

        if (suspendedResult[i]) {
          returnDataArray.suspended.push(suspendedResult[i]);
        } else {
          returnDataArray.suspended.push(0);
        }

        if (terminatedResult[i]) {
          returnDataArray.terminated.push(terminatedResult[i]);
        } else {
          returnDataArray.terminated.push(0);
        }

        i++;
      }
    } else {
      while (i < 13) {
        if (activeResult[i]) {
          returnDataArray.active.push(activeResult[i]);
        } else {
          returnDataArray.active.push(0);
        }

        if (dueResult[i]) {
          returnDataArray.due.push(dueResult[i]);
        } else {
          returnDataArray.due.push(0);
        }

        if (suspendedResult[i]) {
          returnDataArray.suspended.push(suspendedResult[i]);
        } else {
          returnDataArray.suspended.push(0);
        }

        if (terminatedResult[i]) {
          returnDataArray.terminated.push(terminatedResult[i]);
        } else {
          returnDataArray.terminated.push(0);
        }

        i++;
      }
    }

    return returnDataArray;
  } else {
    return returnDataArray;
  }
};

export const COMPANYLEADCHARTDATA = (payload, viewType) => {
  const returnValue = {};
  for (const item of payload) {
    const {
      createdAt,
    } = item;
    const monthQuater = dateManipulationForChart(createdAt, viewType)

    if (!Object.keys(returnValue).includes(monthQuater)) {
      returnValue[monthQuater] = 1;
    } else {
      returnValue[monthQuater]++;
    }
  }
  const returnDataArray = [];

  if (Object.keys(returnValue).length !== 0) {
    let i = 1;
    if (viewType === 'quarter') {
      while (i < 5) {
        if (returnValue[i]) {
          returnDataArray.push(returnValue[i]);
        } else {
          returnDataArray.push(0);
        }
        i++;
      }
    } else {
      while (i < 13) {
        if (returnValue[i]) {
          returnDataArray.push(returnValue[i]);
        } else {
          returnDataArray.push(0);
        }
        i++;
      }
    }
    return returnDataArray;
  } else {
    return returnDataArray;
  }
};

export const TOPCLIENTS = (payload, format, viewType) => {
  const returnValue = {};
  for (const item of payload) {
    const {
      clientName,
      totalCost
    } = item;
    if (viewType === "invoice-deals") {
      if (!Object.keys(returnValue).includes(clientName)) {
        returnValue[clientName] = { cost: Number(totalCost.toFixed(2)), count: 1 };
      } else {
        returnValue[clientName] = { cost: returnValue[clientName].cost + Number(totalCost.toFixed(2)), count: returnValue[clientName].count + 1 };
      }
    } else if (viewType === "deal-forecast") {
      let { forecastAmount } = item;
      if (forecastAmount) {
        if (!Object.keys(returnValue).includes(clientName)) {
          returnValue[clientName] = { cost: Number(forecastAmount), count: 1 };
        } else {
          returnValue[clientName] = { cost: returnValue[clientName].cost + Number(forecastAmount), count: returnValue[clientName].count + 1 };
        }

      }
    }
  }
  let result = [];
  if (format === 'amount') {
    for (const property in returnValue) {
      result.push({ clientName: property, value: returnValue[property].cost })
    }
    result = result.sort(function (a, b) {
      return a.value - b.value;
    }).reverse();

  } else if (format === 'count') {
    for (const property in returnValue) {
      result.push({ clientName: property, value: returnValue[property].count })
    }
    result = result.sort(function (a, b) {
      return a.value - b.value;
    }).reverse();
  }

  let average = 70 / 100;
  let allowed_number = result.length * average;
  allowed_number = allowed_number >= 1 ? allowed_number : 1;

  return result.slice(0, allowed_number);
}

export const GENERALCHARTDATA = (payload, viewType) => {
  // viewType = 'quarter' || 'month'
  const returnValue = {};
  for (const item of payload) {
    const {
      createdAt,
    } = item;
    const monthQuater = dateManipulationForChart(createdAt, viewType)

    if (!Object.keys(returnValue).includes(monthQuater)) {
      returnValue[monthQuater] = 1;
    } else {
      returnValue[monthQuater]++;
    }
  }

  const returnDataArray = [];

  if (Object.keys(returnValue).length !== 0) {
    let i = 1;
    if (viewType === 'quarter') {
      while (i < 5) {
        if (returnValue[i]) {
          returnDataArray.push(returnValue[i]);
        } else {
          returnDataArray.push(0);
        }
        i++;
      }
    } else {
      while (i < 13) {
        if (returnValue[i]) {
          returnDataArray.push(returnValue[i]);
        } else {
          returnDataArray.push(0);
        }
        i++;
      }
    }
    return returnDataArray;
  } else {
    return returnDataArray;
  }
};

export const dateManipulationForChart = (timeStamp, viewType) => {
  const stringDate = new Date(timeStamp);
  const splitCreatedOn = stringDate.toDateString().split(" ")[1].toUpperCase();
  let monthQuaterNumber = (Months.indexOf(splitCreatedOn) + 1)

  if (viewType === 'quarter') {
    if (monthQuaterNumber <= 3) {
      monthQuaterNumber = 1;
    } else if (monthQuaterNumber > 3 && monthQuaterNumber <= 6) {
      monthQuaterNumber = 2;
    } else if (monthQuaterNumber > 6 && monthQuaterNumber <= 9) {
      monthQuaterNumber = 3;
    } else if (monthQuaterNumber > 9 && monthQuaterNumber <= 12) {
      monthQuaterNumber = 4;
    }
  }
  return monthQuaterNumber.toString();
};

export const SALESORDERCHARTDATA = (payload, type) => {
  const returnValue = {};
  for (const item of payload) {
    const { createdDate, totalAmount, status } = item;

    if (type === "totalSalesOrder") {
      const splitCreatedOn = createdDate.split("-");
      const month = splitCreatedOn[1];
      if (!Object.keys(returnValue).includes(month)) {
        returnValue[month] = Number(totalAmount);
      } else {
        returnValue[month] += Number(totalAmount);
      }
    } else if (type === "totalApproved") {
      if (status === 2) {
        const splitCreatedOn = createdDate.split("-");
        const month = splitCreatedOn[1];
        if (!Object.keys(returnValue).includes(month)) {
          returnValue[month] = Number(totalAmount);
        } else {
          returnValue[month] += Number(totalAmount);
        }
      }
    } else if (type === "totalDeclined") {
      if (status === 1) {
        const splitCreatedOn = createdDate.split("-");
        const month = splitCreatedOn[1];
        if (!Object.keys(returnValue).includes(month)) {
          returnValue[month] = Number(totalAmount);
        } else {
          returnValue[month] += Number(totalAmount);
        }
      }
    } else if (type === "totalOpen") {
      if (status === 0) {
        const splitCreatedOn = createdDate.split("-");
        const month = splitCreatedOn[1];
        if (!Object.keys(returnValue).includes(month)) {
          returnValue[month] = Number(totalAmount);
        } else {
          returnValue[month] += Number(totalAmount);
        }
      }
    }
  }

  const returnDataArray = [];

  if (Object.keys(returnValue).length !== 0) {
    for (const item in returnValue) {
      returnDataArray[Number(item) - 1] = Number(returnValue[item]);
    }
    return returnDataArray;
  } else {
    return returnDataArray;
  }
};

// custom validator to check that two fields match
export const MustMatch = (controlName: string, matchingControlName: string) => {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
};

// This will not allow only spaces to be entered.
export function REMOVESPACESONLY(control: AbstractControl) {
  if (control && control.value && !control.value.replace(/\s/g, "").length) {
    control.setValue("");
  }
  return null;
}

export function TrimSpace(control: AbstractControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'whitespace': true };

}

// This will not allow only spaces to be entered.
export function TWODIGITDECIMALINPUT(control: AbstractControl) {
  return (formGroup: FormGroup) => {
    if (control && control.value) {
      // const decimals = control.toString().split(".")[1];
      if (control.value < 0.01 || control.value > 100) {
        control.setErrors({ pattern: true });

        if (control.value.includes(".")) {
          const decimals = control.toString().split(".")[1];
          if (decimals && decimals.length > 2) {
            control.setErrors({ pattern: true });
            return;
          }
        }
      }
      control.setErrors({ pattern: true });
    } else control.setErrors({ pattern: null });
  };
}

// Validate String against Special Characters (Must not contain special characters or blank characters except '_' and '-')
// Return true if string contain such characters

export const CHECKSTRINGSPECIALCHAR = (string) => {
  return (
    !string.trim() ||
    string.startsWith("-") ||
    string.startsWith("_") ||
    !CONTAINSPECIALCHAR.test(string.trim())
  );
};

export const EXTRACTOBJVALUETOARR = (arrObj: any[], key: string) => {
  return arrObj.map((item) => item[key]);
};

export const COMPAREAR_REMOVEMATCH = (
  arrObjList: any[],
  arrObjForCompare: any[],
  key: string
) => {
  let itemToCompare = EXTRACTOBJVALUETOARR(arrObjForCompare, key);
  return {
    newList: arrObjList.filter((res) => !itemToCompare.includes(res[key])),
    removedFrmList: arrObjList.filter((res) =>
      itemToCompare.includes(res[key])
    ),
  };
};

export const COMPAREARRMATCH = (
  arrObjList: any[],
  arrObjForCompare: any[],
  keyA: string,
  keyB: string
) => {
  let itemToCompare = EXTRACTOBJVALUETOARR(arrObjForCompare, keyB);
  return arrObjList.filter((res) => itemToCompare.includes(res[keyA]));
};

export const COMPAREARRMATCH_APPEND = (
  arrObjList: any[],
  arrObjForCompare: any[],
  keyA: string,
  keyB: string
) => {

  const sortedArrObjListByKey = arrObjList.sort(function (a, b) {
    return a[keyA] - b[keyA];
  });

  const sortedarrObjForCompareByKey = arrObjForCompare.sort(function (a, b) {
    return a[keyB] - b[keyB];
  });

  let newInvoiceData = sortedArrObjListByKey.map(element => {
    let teamId = element.teamId;
    let teamName;

    for (let i = 0; i < sortedarrObjForCompareByKey.length; i++) {
      if (teamId === sortedarrObjForCompareByKey[i].teamId) {
        teamName = sortedarrObjForCompareByKey[i].teamName;
        break;
      }
    }
    return teamName ? { ...element, teamName } : { ...element }
  })
  return newInvoiceData;
};

// To Support Safari Date format
export const REFORMATDATE = (arrObj: any[], keys: any[]) => {
  return arrObj.map((item) => {
    keys.forEach((key) => {
      // looking out for this kinda date format and ignore it (works fine on both browsers): 2020-07-30T23:00:00.000Z
      if (item[key].indexOf("T") === -1) {
        item = {
          ...item,
          [key]: item[key].replace(/-/g, "/"),
        };
      }
    });

    return item;
  });
};

export const COMFIRM_FILEDS_ONLY_IN_OBJ = (obj: any, key, expectedCount: number) => {
  let count = 0;
  Object.keys(obj).forEach(field => {
    if (obj[field]) {
      count = count + 1
    } else if (obj['archiveFlag'] === 0) {
      count = count + 1
    }
  })
  if (count === expectedCount && obj[key]) {
    return true;
  } else {
    return false;
  }

}

export const EXTRASALESPERSONTEAMHASHMAP = (payload, type) => {
  let totalInvBySPTeam = {};
  let result = payload.reduce(function (allitems, item) {
    if (type === 'salesperson') {
      let name = item.ownerName ? item.ownerName : 'Unspecified';
      let amount = item.totalCost;
      if (Object.keys(allitems).includes(name)) {
        allitems[name].push(item);
        totalInvBySPTeam[name] = amount + totalInvBySPTeam[name];
      } else {
        allitems[name] = [];
        allitems[name].push(item)
        totalInvBySPTeam[name] = amount
      }
    } else if (type === 'team') {
      let name = item.teamName ? item.teamName : 'Unknown';
      let amount = item.totalCost;
      if (Object.keys(allitems).includes(name)) {
        allitems[name].push(item);
        totalInvBySPTeam[name] = amount + totalInvBySPTeam[name];
      } else {
        allitems[name] = [];
        allitems[name].push(item)
        totalInvBySPTeam[name] = amount
      }
    }
    return allitems
  }, {})
  return [result, Object.values(totalInvBySPTeam)];
}

export const REFACTORTEAMSARRRESPONSE = (data, userTeamID) => {
  return data.map((dat) => {
    if (dat.id == userTeamID) {
      return {
        teamId: dat.id,
        teamName: "Self",
      };
    } else {
      if (dat.self === 1) {
        const teamname = dat.teamName.split(" ");
        return {
          teamId: dat.id,
          teamName: `${teamname[0]} ${teamname[1]} Team`,
        };
      } else {
        return { teamId: dat.id, teamName: dat.teamName };
      }
    }
  })
}
